jQuery(document).ready(function ($) {

    /**
     * remove extra footer in form page
     */
    if(document.URL.indexOf("ajuda-personalizada") >= 0){
        $('.footer-wrapper').remove();
    }

    let required = '<p class="is-empty">* Campo de resposta obrigatória.</p>'

    let $app = $('.container-app-js');

    $("#datepicker-parar-js").datepicker({
        changeMonth: true,
        changeYear: true,
        dateFormat: 'dd/mm/yy',
        defaultDate: null
    }).on('change', function () {
        // $(this).valid();
    });

    $('.printer-js').click((event) => {
        event.preventDefault();
        window.print()
    });

    $(".select-steps-js").change(function () {
        window.location.href = '?passo=' + this.value;
    });

    $app.find('form').submit(function (event) {
        event.preventDefault();

        if (!valForm()) {
            anchorPage();
            return;
        }

        $.post(
            i18n.ajax_url,
            {
                'action': 'add_questionnarie',
                'data': $(this).serializeArray()
            },
            function (response) {
                location.reload();
                $('html, body').animate({ scrollTop: 10 }, 300, 'easeInSine');
            }
        );

        $(".btn-bee--js").append('<img class="loader" height="40" src="/wp-content/themes/jupiter-child/assets/images/loader4.svg">');

        // Remove a possibilidade de multiplos cliques
        $(".btn-bee--js input").attr('disabled', 'disabled');
    });

    function valForm() {
        let isValid = false;
        if ((valRadio() + valTextArea() + valInputText() + valSelect() + valdate()) === 5) {
            isValid = true;
        }

        return isValid;
    }

    function anchorPage() {
        let $is_empty = $('p.is-empty:first');
        let offset = $is_empty.offset();

        $('html, body').animate({ scrollTop: (offset.top - 300) }, 300, 'easeInSine');
    }

    function valRadio() {
        let names = [];
        let notEmpty = 1;
        $('input[type="radio"]').not('.no-require').each(function () {
            names[$(this).attr('name')] = true;
        });

        for (name in names) {
            let radio_buttons = $("input[name='" + name + "']");
            if (radio_buttons.filter(':checked').length == 0) {
                console.log('none checked in ' + name);
                if (radio_buttons.closest('.group_field').children('p.is-empty').length === 0
                    && radio_buttons.closest('.radio_button_field').children('p.is-empty').length === 0
                &&  radio_buttons.closest('.radio_button_field_gender').children('p.is-empty').length === 0) {
                    radio_buttons.closest('.group_field').append(required).focus();
                    radio_buttons.closest('.radio_button_field').append(required).focus();
                    radio_buttons.closest('.radio_button_field_gender').append(required).focus();

                }
                notEmpty = 0;
            } else {

                if ($('input[name="' + name + '"]').closest('.group_field').children('p.is-empty').length > 0
                    || $('input[name="' + name + '"]').closest('.radio_button_field').children('p.is-empty').length > 0) {
                    $('input[name="' + name + '"]').closest('.group_field').children('p.is-empty').remove();
                    $('input[name="' + name + '"]').closest('.radio_button_field').children('p.is-empty').remove();
                }
            }
        }
        return notEmpty;
    }

    function valTextArea() {
        let names = [];
        let notEmpty = 1;
        $('textarea').not('.no-require').each(function () {
            names[$(this).attr('name')] = true;
        });

        //text_field
        for (name in names) {
            let textArea_name = $("textarea[name='" + name + "']");
            if (textArea_name.val() === "") {
                console.log('none checked in ' + name);
                if (textArea_name.closest('.text_field').children('p.is-empty').length === 0) {
                    textArea_name.closest('.text_field').append(required).focus();
                }
                notEmpty = 0;
            } else {
                if (textArea_name.closest('.text_field').children('p.is-empty').length > 0) {
                    textArea_name.closest('.text_field').children('p.is-empty').remove();
                }
            }
        }
        return notEmpty;
    }

    function valInputText() {
        let names = [];
        let notEmpty = 1;
        $('input[type="text"]').not('.no-require').each(function () {
            names[$(this).attr('name')] = true;
        });


        for (name in names) {
            let text_input_field = $("input[name='" + name + "']");
            if (text_input_field.val() === "") {
                console.log('none checked in ' + name);
                if (text_input_field.closest('.text_field').children('p.is-empty').length === 0) {
                    text_input_field.closest('.text_field').append(required).focus();
                }
                notEmpty = 0;
            } else {
                if (text_input_field.closest('.text_field').children('p.is-empty').length > 0) {
                    text_input_field.closest('.text_field').children('p.is-empty').remove();
                }
            }
        }
        return notEmpty;
    }

    function valSelect() {
        let names = [];
        let notEmpty = 1;
        $('select').not('.no-require').each(function () {
            names[$(this).attr('name')] = true;
        });


        for (name in names) {
            let text_input_field = $("select[name='" + name + "']");
            if (text_input_field.val() === "") {
                console.log('none checked in ' + name);
                if (text_input_field.closest('.select_field').children('p.is-empty').length === 0) {
                    text_input_field.closest('.select_field').append(required).focus();
                }
                notEmpty = 0;
            } else {
                if (text_input_field.closest('.select_field').children('p.is-empty').length > 0) {
                    text_input_field.closest('.select_field').children('p.is-empty').remove();
                }
            }
        }
        return notEmpty;
    }

    function valdate() {
        let names = [];
        let notEmpty = 1;
        $('input[type="date"]').not('.no-require').each(function () {
            names[$(this).attr('name')] = true;
        });

        if ($('input.hasDatepicker').val() === "") {
            $('input.hasDatepicker').closest('.text_field').append(required).focus();
            notEmpty = 0;
        }

        for (name in names) {
            let text_input_field = $("input[name='" + name + "']");
            if (text_input_field.val() === "") {
                console.log('none checked in ' + name);
                if (text_input_field.closest('.text_field').children('p.is-empty').length === 0) {
                    text_input_field.closest('.text_field').append(required).focus();
                }
                notEmpty = 0;
            } else {
                if (text_input_field.closest('.text_field').children('p.is-empty').length > 0) {
                    text_input_field.closest('.text_field').children('p.is-empty').remove();
                }
            }
        }
        return notEmpty;
    }




    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step1-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_1').then((response) => {
            $(this).html('Enviado com sucesso!');
        });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step2-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_2').then((response) => {
            $(this).html('Enviado com sucesso!');
        });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step3-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_3').then((response) => {
            $(this).html('Enviado com sucesso!');
        });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step4-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_4').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step5-social-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_5_social').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step5-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_5').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step6-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_6').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step7-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_7').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step8-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_8').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step9-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_9').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    /**
     * Envia o email para o profissional de saúde
     * informando um status sobre a situação do cidadão.
     * DPOC
     */
    $('.send-report-step10-js').click(function (event) {
        event.preventDefault();
        let user_id = $(this).data('userid');

        $(this).html('Enviando ...');

        request_by_action(user_id, 'send_report_step_10').then((response) => {
            $(this).html('Enviado com sucesso!');
    });
    });

    function request_by_action(user_id, function_name) {

        return $.post(
            ajaxurl, // ajaxurl funciona dentro do backoffice
            {
                'action': function_name,
                'user_id': user_id
            },
            function (response) {
                console.log(response);
                return response;
            }
        );
    }

    function deaths() {

        let average_dead_people_per_year = 7000000
        let deaths_per_day = average_dead_people_per_year / 365;
        let deathsPerSecond = (((7000000 / 365) / 24) / 60) / 60;

        let createDate = $('.deaths-couter-js').text();
        let currentDate = Date.now();
        let today = new Date(currentDate);

        var date2 = createDate;
        date2 = new Date(date2.split('/')[2], date2.split('/')[1] - 1, date2.split('/')[0]);

        var timeDiff = Math.abs(date2.getTime() - today.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 ));
        var total = deaths_per_day * diffDays;

        setInterval(function () {
            total += deathsPerSecond;
            $('.deaths-couter-js').text(total.toFixed(2));
        }, 1000);

    }
    if($('.deaths-couter-js').text() !== ""){
        deaths();
    }

    function spider_chart() {
        var marksCanvas = document.getElementById("spider-chart-js");
        Chart.defaults.global.defaultFontFamily = "Lato";
        Chart.defaults.global.defaultFontSize = 10;

        var marksData = {
            labels: ["PF", "RP", "BP", "GH", "VT", "SF", "RE", "MH", "HT"],
            datasets: fillData
        };
       // var fillData = $('#spider-chart').attr('data-chart-content');

        var chartOptions = {
            scale: {
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100,
                    stepSize: 20
                },
                pointLabels: {
                    fontSize: 16
                }
            },
            legend: {
                position: 'left'
            }
        };

        var radarChart = new Chart(marksCanvas, {
            type: 'radar',
            data: marksData,
            options: chartOptions
        });
    }
    if($('#spider-chart').text() !== ""){
        spider_chart();
    }

    function spider_chart_pees() {
        var marksCanvas = document.getElementById("spider-chart-js");
        Chart.defaults.global.defaultFontFamily = "Lato";
        Chart.defaults.global.defaultFontSize = 10;

        var marksData = {
            labels: ["Sentido", "Confiança", "Autonomia", "Impacto", "Oportunidade", "Informação", "Apoio", "Recursos", "Poder Formal", "Poder Informal", "Satisfação"],
            datasets: fillData
        };

        var chartOptions = {
            scale: {
                ticks: {
                    beginAtZero: true,
                    min: 0,
                    max: 100,
                    stepSize: 10
                },
                pointLabels: {
                    fontSize: 16
                }
            },
            legend: {
                position: 'left'
            }
        };

        var radarChart = new Chart(marksCanvas, {
            type: 'radar',
            data: marksData,
            options: chartOptions
        });
    }
    if($('#spider-chart-pees').text() !== ""){
        spider_chart_pees();
    }

});


// WEBPACK FOOTER //
// ./src/js/app-questionnarie.js